import React, {useState, useEffect} from "react";
import Spinner from "react-bootstrap/Spinner";
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SweetAlert from 'react-bootstrap-sweetalert'
import CustomButton from "components/CustomButtons/Button";
import Button from 'react-bootstrap/Button'
import CustomReactSelect from 'components/Store/CustomReactSelect';
import {apiRequest} from 'util/api/util'
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from "react-hook-form";
import FormGroup from 'components/Form/FormGroup'
import * as Yup from 'yup'
import Modal from 'react-bootstrap/Modal'
import { addReservation, addStudentToClass } from 'store/actions/dashboardActions'
import { loadClientList } from 'store/actions/clientActions'
import * as moment from 'moment-timezone'
import { DevTool } from "react-hook-form-devtools";

function isEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

const buildPurchaseTitle = (purchase) => {
    let title = purchase.offering.name

    title += " • "

    switch (purchase.offering.type) {
    case "challenge":

        title += `Renews ${moment(purchase.expires * 1000).format("LL")}`

    case "subscription":
        if (purchase.canceled) {
            title += `Expires ${moment(purchase.expires * 1000).format("LL")}`
        } else {
            title += `Renews ${moment(purchase.expires * 1000).format("LL")}`
        }

        if (purchase?.offering?.subscriptionType === 'limited') {
            title += `${purchase.remaining} remaining • ` + title
        }
        break
    case "pack":
        title += `${purchase.remaining} remaining`
        break
    }

    return title
}

function AddNewStudent(props) {

    const dispatch = useDispatch()
    const partnerId = useSelector(state => state.instructor?.instructor?.platformID)

    useEffect(() => {
        if (partnerId) {
            dispatch(loadClientList(partnerId))
        }
    }, [dispatch, partnerId])

    const clients = useSelector(state => state.clients.clients.map(val => {
        var name = val.name
        if (val.lastName && val.firstName) {
            name = `${val.firstName} ${val.lastName}`
        } else if (val.firstName) {
            name = val.firstName
        } else if (!name) {
            name = "unknown"
        }
        var email = val.email || "email unknown"
        var phone = val.phone || val.phoneNumber || "unknown"
        var marketingOptIn = val.marketingOptIn === false ? false : true
        return {
            label: name + " • " + email,
            value: val.id,
            name: name,
            email: email
        }
    }))

    const clientMap = clients.reduce((map, val) => {
        if (val.value) {
            map[val.value] = val;
        }
        return map;
    }, {});

    const clientOptions = [
        // {
        //     label: "New Student",
        //     value: "none"
        // },
        {
            label: "Add new student",
            value: "new"
        },
        ...clients
    ]

    const defaultPackageOptions = [
        {
            label: "Add for free",
            value: "free"
        }
    ]

    const [packageOptions, setPackageOptions] = React.useState(defaultPackageOptions)

    const {classId} = props
    const [isLoading, setIsLoading] = React.useState(false)
    const [savingError, setSavingError] = React.useState(false)

    const { register, control, handleSubmit, setValue, getValues, formState, reset, errors, watch } = useForm({
        mode: 'onBlur',
        validationSchema: Yup.object({
            userId: Yup.string().required(),
            // purchaseId: Yup.string(),
            // clientName: Yup.string().required('This field is required'),
            // lastName: Yup.string().required('This field is required'),
            // clientEmail: Yup.string().email("Please enter a valid email address").required('This field is required'),
            // sendConfirmationEmail: Yup.boolean()
        }),
        defaultValues: {
            userId: "",
            clientName: "",
            clientEmail: "",
            purchaseId: "free"
        }
    });

    const { dirty, isValid } = formState;

    const {userId} = watch()

    // useEffect(() => {
    //     // register({ name: 'purchaseId'})
    // }, [register])

    const fetchCheckoutData = (userId) => {

        if (!userId) {
            return
        }

        setPackageOptions([
            {
                label: "Add for free",
                name: "free"
            }
        ])

        setIsLoading(true)

        apiRequest(`app/dashboard/getCheckout`, 'POST', {
            userId: userId,
            classId: classId
        })
            .then(response => {
                
                const purchases = response?.purchases

                const options = purchases.map(val => {
                    return {
                        label: buildPurchaseTitle(val),
                        value: val.id
                    }
                })

                if (options.length > 0) {
                    const first = options[0].value
                    setValue('purchaseId', first)
                }

                setPackageOptions([
                    {
                        label: "Add for free",
                        name: "free"
                    },
                    ...options
                ])

                setIsLoading(false)

            })
            .catch(err => {

                setIsLoading(false)
                console.log("Error with options: ", err)

                window.alert("Error: ", JSON.stringify(err))
                
            })

    }

    const onSubmit = (data) => {
        console.log("submitting data: ", data)

        if (!data.purchaseId) {
            data.purchaseId = 'free'
        }

        console.log("Is email: ", isEmail(data.userId))
        if (data.userId === 'new' || isEmail(data.userId)) {
            const client = clientMap[data.userId]

            console.log("Client: ", client)
            if (isEmail(data.userId) && client) {
                data.userId = 'new'
                data.clientName = client.name
                data.clientEmail = client.email
                // setValue('clientName', client.name)
                // setValue('clientEmail', client.email)
            }
            if (!data.clientName || !data.clientEmail) {
                window.alert("Must provide name and email")
                return
            }
        }

        console.log("DATA: ", data)
        
        setIsLoading(true)
        dispatch(addStudentToClass({
            ...data,
            classId: classId
        }))
        .then(val => {
            setIsLoading(false)
            reset({
                userId: "",
                purchaseId: "free"
            })
        })
    }

    console.log("New package options: ", packageOptions)
    return (<>
        <div>
            <div>
                {savingError && (
                    <div className="alert alert-danger" role="alert">
                        {savingError}
                    </div>
                )}
                <form className={"addClientForm "} onSubmit={handleSubmit(onSubmit)} noValidate={true}>
    
                    <div className="row mb-2">
                        <Controller
                            className="col-sm-12 col-md-6"
                            type="text"
                            as={CustomReactSelect}
                            options={clientOptions}
                            control={control}
                            setValue={setValue}
                            getValues={getValues}
                            placeholder="Type to add new student"
                            name="userId"
                            newSelection={(value) => {
                                setValue('purchaseId', "free")
                                fetchCheckoutData(value)
                                console.log("New student selection: ", value)
                                // const client = clientMap[value]
                                // if (client) {
                                //     setValue('clientName', client.name)
                                //     setValue('clientEmail', client.email)
                                // }
                            }}
                        />
                    </div>

                    <div className={userId === 'new' ? '' : 'd-none'}>

                        <input 
                            ref={register} 
                            type={'text'}
                            placeholder={'Student name'} 
                            name={'clientName'} 
                            className={"form-control col-sm-12 col-md-6 mb-2"} 
                        />

                        <input 
                            ref={register} 
                            type={'text'}
                            placeholder={'Student email'} 
                            name={'clientEmail'} 
                            className={"form-control col-sm-12 col-md-6 mb-2"} 
                        />

                    </div>

                    <div className={"row " + (userId ? "" : "d-none")}>
                        <Controller
                            disabled={isLoading}
                            className={"col-sm-12 col-md-6 "}
                            type="text"
                            as={CustomReactSelect}
                            options={packageOptions}
                            control={control}
                            setValue={setValue}
                            getValues={getValues}
                            placeholder="Select Package"
                            name="purchaseId"
                        />

                        <div className="d-flex col-1">
                            <button disabled={isLoading} type="submit" className="btn btn-primary">
                                
                                <span>{"Add"}</span>
        
                                {isLoading && (
                                    <Spinner
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden={true}
                                    className="ml-2"
                                    >
                                    <span className="sr-only">Saving...</span>
                                    </Spinner>
                                )}
                            </button>
                        </div>
                    </div>
                    
                </form>
            </div>
            <DevTool control={control} />
        </div>
        </>
    );
}
export default AddNewStudent;